import user from './userReducer';

export default {
	user
}